import React from 'react';
import { Box } from '@mui/material';
import { AnyEvent, ExpertEvent, MockEvent } from './types';
import { EventRow } from './EventRow';
import { ExpertEventRow } from './ExpertEventRow';

interface EventTimelineProps {
  events: AnyEvent[];
  onEventClick: (event: AnyEvent) => void;
  onToggleComplete: (eventId: number, isCompleted: boolean) => void;
  onDelete: (event: AnyEvent) => void;
  onEdit: (event: AnyEvent) => void;
}

export const EventTimeline: React.FC<EventTimelineProps> = ({ events, onEventClick, onToggleComplete, onDelete, onEdit }) => {
  return (
    <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, mx: 1, boxShadow: 1, overflow: 'hidden' }}>
      {events.map((event, idx) => (
        <Box key={event.id}>
          {event.fromExpert
            ? <ExpertEventRow
                event={event as ExpertEvent}
                onClick={() => onEventClick(event)}
                onToggleComplete={(isDone) => onToggleComplete(event.id, isDone)}
              />
            : <EventRow
                event={event as MockEvent}
                onClick={() => onEventClick(event)}
                onToggleComplete={(isDone) => onToggleComplete(event.id, isDone)}
                onDelete={() => onDelete(event)}
                onEdit={() => onEdit(event)}
              />
          }
          {idx < events.length - 1 && (
            <Box sx={{ mx: 2, borderBottom: '1px solid', borderColor: 'divider' }} />
          )}
        </Box>
      ))}
    </Box>
  );
};
